import { useState } from 'react';
import PharmacyLetterForm from './components/PharmacyLetterForm';
import CareMapprIconButton from '../../../../components/Button/CareMapprIconButton';
import { Download } from 'react-bootstrap-icons';
import editIcon from '../../../../../assets/img/button-icons/edit-pen-outline.svg';

import { Collapse } from 'react-bootstrap';
import { LetterType } from './PharmacistDoctorLetterSection';
import { useLettersForm } from './provider/LettersFormContext';
import CareMapprButton from '../../../../components/Button/CareMapprButton';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';

const PharmacistLetter = () => {
  const { isDownloadingPharmacist, onDownloadLetter } = useLettersForm();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex align-items-center justify-content-between px-2">
        <span className="letters-label">Pharmacy letter</span>
        <div className="d-flex align-items-center gap-2">
          <CareMapprIconButton
            className="m-0 min-width-50"
            icon={<img src={editIcon} className="icon" alt="edit pen icon" />}
            onClick={() => {
              setIsOpen(true);
            }}
          />
          <CareMapprButton
            extraClassNames="action-button"
            label={isDownloadingPharmacist ? 'Downloading' : 'Download'}
            disabled={isDownloadingPharmacist}
            variant="secondary"
            endIcon={
              isDownloadingPharmacist ? (
                <LoadingSpinner size={16} color="primary" showText="" />
              ) : (
                <Download size={16} />
              )
            }
            type="button"
            onClick={() => {
              onDownloadLetter(LetterType.PHARMACIST);
            }}
          />
        </div>
      </div>
      <Collapse in={isOpen}>
        <div>
          <PharmacyLetterForm onClose={() => setIsOpen(false)} />
        </div>
      </Collapse>
    </div>
  );
};

export default PharmacistLetter;
